import React from 'react';
import { Link } from 'react-router-dom';
// Constants
import {
  CompanyName,
  CompanyTagLine,
  MainTitle,
  SubtitleMain,
} from '../../utils/Constants';
import { ABOUT_PAGE_URL, COMMERCIALS_PAGE_URL } from '../../utils/Routes';
// Images
import MainImage from '../../assets/images/people/siv-renate-main.webp';
// Icons
import { MdDoubleArrow } from 'react-icons/md';

function HomePageHeader() {
  return (
    <header className='grid min-h-screen pt-[84px] w-full h-full overflow-x-hidden'>
      {/* Phone */}
      <section className='grid lg:hidden px-8 py-4 w-full'>
        <article className='grid justify-center'>
          <div className='grid h-fit gap-y-4 text-center'>
            <h1
              className='font-agraham text-4xl w-full text-colour5 tracking-wide'
              style={{ textShadow: '2px 2px 8px rgba(0,0,0,0.6)' }}
            >
              {CompanyName}
            </h1>
            <div className='text-base font-titleFont text-center px-8'>
              <h2>{CompanyTagLine}</h2>
            </div>
          </div>
          <div className='grid justify-center'>
            <img
              src={MainImage}
              alt={`${CompanyName} fitness header`}
              className='max-w-xs border_special'
            />
          </div>
          <div className='grid justify-center w-full'>
            <Link
              to={COMMERCIALS_PAGE_URL}
              aria-label={`Learn more`}
              className='grid text-xl md:text-sm w-full p-1 bg-colour5 text-colour1 shadow-lg font-semibold font-poppins hover:brightness-90 duration-200 h-fit'
            >
              <div className='grid grid-cols-rev items-center border-[1px] border-colour1 border-solid gap-x-8 py-1 px-4'>
                <span>Learn More</span>
                <MdDoubleArrow className='text-xl' />
              </div>
            </Link>
          </div>
          <div className='text-center text-lg'>
            <p>
              Creating commericals, media editing and offering classes and
              advice in body and mental wellness.
            </p>
          </div>
          {/* Cta */}
          <section className='grid grid-cols-3 gap-x-2 w-full justify-center text-center'>
            <Link
              to={ABOUT_PAGE_URL}
              className='text-colour5 underline underline-offset-4 hover:brightness-75'
              aria-label='Learn more about Siv Renate'
              title='About Siv Renate'
            >
              About
            </Link>

            <Link
              to={ABOUT_PAGE_URL}
              className='text-colour5 underline underline-offset-4 hover:brightness-75'
              aria-label='Explore Siv Renate’s commercials and UGC portfolio'
              title='Commercials and UGC portfolio by Siv Renate'
            >
              Commercials
            </Link>

            <Link
              to={ABOUT_PAGE_URL}
              className='text-colour5 underline underline-offset-4 hover:brightness-75'
              aria-label='Discover Siv Renate’s wellness and lifestyle work'
              title='Wellness and lifestyle portfolio by Siv Renate'
            >
              Wellness
            </Link>
          </section>
        </article>
      </section>

      {/* Large screen */}
      <section className='hidden relative lg:grid w-full'>
        {/* LEFT rail */}
        <div className='absolute inset-y-0 left-0 w-12 z-20 grid place-items-center'>
          <span className='[writing-mode:vertical-rl] rotate-180 [text-orientation:mixed] underline underline-offset-4'>
            {MainTitle}
          </span>
        </div>

        {/* RIGHT rail */}
        <div className='absolute inset-y-0 right-0 w-12 z-20 grid place-items-center'>
          <span className='[writing-mode:vertical-rl] rotate-180 [text-orientation:mixed] underline underline-offset-4'>
            {SubtitleMain}
          </span>
        </div>
        <div className='grid relative w-full h-full px-8'>
          <img
            src={MainImage}
            alt={`${CompanyName} fitness header`}
            className='absolute grid items-center w-full transform -translate-x-1/2 h-auto max-w-sm top-[2rem] -translate-y-0 left-1/3 border_special'
          />
        </div>

        <article className='grid w-full h-full pt-16 grid-rows-reg'>
          <section className='relative text-center px-12'>
            <div className='hidden lg:block absolute text-xl font-titleFont -top-[2rem] text-center left-1/2'>
              <h2 className='text-sm'>{CompanyTagLine}</h2>
            </div>
            <h1
              className='font-agraham text-[6.5rem] 2xl:text-[12rem] w-full text-colour5 tracking-wide'
              style={{ textShadow: '2px 2px 8px rgba(0,0,0,0.6)' }}
            >
              {CompanyName}
            </h1>
          </section>
          <section className='grid w-full px-12'>
            <div className='grid h-fit grid-cols-rev pr-8 pt-8 xl:pr-44'>
              <div className='grid items-center text-center'>
                <p className='text-sm xl:text-base'>
                  Creating commericals, media editing and offering classes and
                  advice in body and mental wellness.
                </p>
              </div>
              <div className='relative z-[999] pointer-events-auto'>
                <a
                  href='#about'
                  aria-label='Learn more'
                  className='relative z-[1000] pointer-events-auto grid text-xl md:text-sm w-full p-1 bg-colour5 text-colour1 shadow-lg font-semibold font-poppins hover:brightness-90 duration-200 h-fit'
                >
                  <div className='grid grid-cols-rev items-center border-[1px] border-colour1 border-solid gap-x-8 py-1 px-4'>
                    <span>Learn More</span>
                    <MdDoubleArrow className='text-xl' />
                  </div>
                </a>
              </div>
            </div>
            <section className='grid items-end py-6'>
              <div className='grid h-fit grid-cols-2 '>
                <div className='grid items-center'>
                  <div className='h-[2px] w-full bg-colour5'></div>
                </div>

                <section className='grid grid-cols-3 text-lg font-semibold gap-x-2 w-full justify-center text-center'>
                  <Link
                    to={ABOUT_PAGE_URL}
                    className='text-colour5 underline underline-offset-4 hover:brightness-75'
                    aria-label='Learn more about Siv Renate'
                    title='About Siv Renate'
                  >
                    About
                  </Link>

                  <Link
                    to={ABOUT_PAGE_URL}
                    className='text-colour5 underline underline-offset-4 hover:brightness-75'
                    aria-label='Explore Siv Renate’s commercials and UGC portfolio'
                    title='Commercials and UGC portfolio by Siv Renate'
                  >
                    Commercials
                  </Link>

                  <Link
                    to={ABOUT_PAGE_URL}
                    className='text-colour5 underline underline-offset-4 hover:brightness-75'
                    aria-label='Discover Siv Renate’s wellness and lifestyle work'
                    title='Wellness and lifestyle portfolio by Siv Renate'
                  >
                    Wellness
                  </Link>
                </section>
              </div>
            </section>
          </section>
        </article>
      </section>
    </header>
  );
}

export default HomePageHeader;
